"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultKeywordWidth = exports.fillKeywordSettingsWithDefaultValues = exports.fillKeywordDataWithDefaultValues = void 0;
const enums_1 = require("./enums");
const root_1 = require("../root");
const keyword_width_enum_1 = require("./enums/keyword-width.enum");
/** @deprecated use fillKeywordSettingsWithDefaultValues instead */
function fillKeywordDataWithDefaultValues(keywordData, featureFlags) {
    return fillKeywordSettingsWithDefaultValues(keywordData, featureFlags);
}
exports.fillKeywordDataWithDefaultValues = fillKeywordDataWithDefaultValues;
function fillKeywordSettingsWithDefaultValues(settingsBearer, featureFlags) {
    var _a, _b, _c, _d, _e;
    const documentSearchEnabled = featureFlags.includes(root_1.FeatureFlag.MatchingProfile_BroadOrNarrowSearchInDocuments);
    const filterLogic = (_a = settingsBearer.filterLogic) !== null && _a !== void 0 ? _a : enums_1.FilterLogic.Filter;
    return {
        ...settingsBearer,
        searchType: (_b = settingsBearer.searchType) !== null && _b !== void 0 ? _b : (documentSearchEnabled ? enums_1.SearchType.NoticeAndDocument : enums_1.SearchType.Notice),
        filterLogic: (_c = settingsBearer.filterLogic) !== null && _c !== void 0 ? _c : enums_1.FilterLogic.Filter,
        searchLogic: (_d = settingsBearer.searchLogic) !== null && _d !== void 0 ? _d : enums_1.SearchLogic.ExactMatch,
        highlightColor: (_e = settingsBearer.highlightColor) !== null && _e !== void 0 ? _e : (filterLogic === enums_1.FilterLogic.Filter ? enums_1.HighlightColor.Green : enums_1.HighlightColor.Yellow),
    };
}
exports.fillKeywordSettingsWithDefaultValues = fillKeywordSettingsWithDefaultValues;
function getDefaultKeywordWidth(ownership) {
    // BF has narrow as default setting
    return ownership === root_1.UserOwnership.Byggfakta ? keyword_width_enum_1.KeywordWidth.Narrow : keyword_width_enum_1.KeywordWidth.Broad;
}
exports.getDefaultKeywordWidth = getDefaultKeywordWidth;
